import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { PageLoadingIndicator } from '../components'
import '../styles/application.css'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob(
      [
        '../pages/**/*.tsx',
        '!../pages/**/__tests__/**',
        '!../pages/**/*.test.tsx',
        '!../pages/**/*.spec.tsx',
      ],
      { eager: true }
    )
    return pages[`../pages/${name}.tsx`]
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <>
        <PageLoadingIndicator />
        <App {...props} />
      </>
    )
  },
})
